import axios from "~/plugins/axios";

export default {
  outgoingCall(phoneNumber) {
    return axios.get("/web_api/v1/voip/call", {
      params: {
        phone_number: phoneNumber,
      },
    })
      .then((response) => response.data);
  },
  getStatus() {
    return axios
      .get("/web_api/v1/voip/status")
      .then((response) => response.data);
  },
  setStatus(status) {
    return axios
      .put("/web_api/v1/voip/status", { status })
      .then((response) => response.data);
  },
};
